<footer>
  <!--<span>{{ today | date: 'yyyy-MM-dd' }}</span>-->
  Fototax © 2021
</footer>
